import {useEffect} from 'react';
import {useAppSelector} from './app';
import {useAuthAxios} from './useAuthAxios';
import {useExpiresToken} from './useExpiresToken';

const PING_INTERVAL_MS = 5 * 60 * 1000;

export const useOnlinePing = (): void => {
    const axios = useAuthAxios();
    const {token} = useAppSelector(state => state.app);
    const {not_expires} = useExpiresToken();

    useEffect(() => {
        if (!token?.token || !not_expires) {
            return;
        }

        const ping = () => {
            axios.post('user/ping').catch(() => undefined);
        };

        ping();
        const intervalId = window.setInterval(ping, PING_INTERVAL_MS);

        return () => window.clearInterval(intervalId);
    }, [token?.token, not_expires, axios]);
};
